module.exports = __webpack_public_path__ + "img/utility-pill-bg-2.9237205e.png";